/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiInternalGetRecords } from '@/api/customerInternal';
export default /*#__PURE__*/_defineComponent({
  __name: 'internalTicketVer',
  props: {
    internalTicketData: {
      type: Object
    }
  },
  setup(__props) {
    const props = __props;
    const columns = [{
      label: '设备号',
      prop: 'deviceNum'
    }, {
      label: 'SDK版本号',
      prop: 'sdkVersion'
    }, {
      label: '支付时间',
      prop: 'purchaseDate'
    }, {
      label: '档位',
      prop: 'transactionId'
    }, {
      label: '道具名称',
      prop: 'propName'
    }, {
      label: '平台订单号',
      prop: 'cmgeOrderNum'
    }];
    const getTableData = () => {
      const params = {
        loginName: props.internalTicketData && props.internalTicketData.loginName,
        productId: props.internalTicketData && props.internalTicketData.productId,
        pageSize: 10,
        PageNum: current.value
      };
      tableLoading.value = true;
      apiInternalGetRecords(params).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
          total.value = res.total;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    watch(() => props.internalTicketData, val => {
      if (val) {
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createBlock(_component_u_card_pane, {
        name: "internalTicketVer"
      }, {
        default: _withCtx(() => [_createVNode(UTable, {
          options: columns,
          data: _unref(tableData),
          loading: _unref(tableLoading),
          pagination: "",
          "current-page": _unref(current),
          "page-size": _unref(pageSize),
          total: _unref(total),
          onSizeChange: _unref(handleSizeChange),
          onCurrentChange: _unref(handleCurrentChange)
        }, null, 8, ["data", "loading", "current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])]),
        _: 1
      });
    };
  }
});